import React, {Component} from "react";
import './home.css';


class Home extends Component{


    /**
     * This method render the information with HTML code
     * @returns Return page information inside HTML
     */
    render(){
        return(
            <div>

                <h1>Página Inicial</h1>

                <div>
                    <p>Aceda sem limites a séries e filmes. Veja em qualquer lugar. Cancele quando quiser</p>
                </div>

                <div id="homeMainDiv">
                    <p id="p2">Veja no seu televisor. Utilize uma Smart TV, Playstation, Xbox, Chromecast, Android TV, Apple TV e leitores de Blu-ray.</p>
                </div>

                <div>
                    <p id="p3">Passe o seu tempo livre com a melhor seleção do mundo cinematográfico na sua casa!</p>
                </div>

            </div>
        );
    }

}

export default Home;
